import r from "../../utils/classNames/index.js";

const t = (t, e) => r("absolute w-0 h-0 border-solid", e, (() => {
    switch (t) {
      case "top":
      case "top-start":
      case "top-end":
        return "border-x-transparent border-x-[10px] border-b-0 border-t-[20px] top-full left-1/2 transform -translate-x-1/2";

      case "bottom":
      case "bottom-start":
      case "bottom-end":
        return "border-x-transparent border-x-[10px] border-b-[20px] border-t-0 bottom-full left-1/2 transform -translate-x-1/2";

      case "left":
      case "left-start":
      case "left-end":
        return "border-y-transparent border-y-[10px] border-l-[20px] border-r-0 left-full top-1/2 transform -translate-y-1/2";

      case "right":
      case "right-start":
      case "right-end":
        return "border-y-transparent border-y-[10px] border-r-[20px] border-l-0 right-full top-1/2 transform -translate-y-1/2";

      default:
        return "";
    }
})());

export { t as getArrowClassName };
//# sourceMappingURL=util.js.map
